import { NgModule } from '@angular/core'
import { PaystackComponent } from './paystack.component'
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ PaystackComponent ],
  imports: [ CommonModule ],
  exports: [ PaystackComponent ]
})
export class PaystackModule { }
